import React from 'react'
import { Form, Button, Col, Row, ModalHeader, ModalBody, ModalFooter, Input, Label, Table } from 'reactstrap';
import { KYC_DATA_AUTOMATION_VARIABLES } from './constant';
import '../style.scss';
import { getPanChecks, getGstFilingChecks, getBankChecks,getVehicleNumberChecks,getStatusCheck, getFailureReason,
    getEmailIdChecks, getChallanChecks, getTanChecks, getKybChecks,getFSSAIChecks } from './helper';
import { getMappedRatingData } from '../../RatingCompanyMap/helper'
import MyAutosuggest from '../../../../components/ReusableComponents/AutoSuggest/index';

export const KycDataAutomation = (props) => {
    let ratingMappedData = getMappedRatingData(props.companyNames)
    return (
        <div style={{ width: '110%' }}>
            <ModalHeader>
                <span>Select Kyc Crawlers</span>
                <span className='text-end'>
                    <Button Color='info' onClick={props.getKycCrawlerStatus}>
                        <i className="fa fa-refresh"></i>&nbsp; Status
                    </Button>

                </span>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <div>
                        <Row>
                            <Col className="col-sm-4" >
                                <Label>Company Name:</Label></Col>
                            <Col className="col-sm-18">
                                <input type="text" name="counterpartyName" value={props.kycCrawlerData.counterpartyName} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter company name" className="form-control mca-data" required />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col className="col-sm-4" >
                                <Label>Participant Name:</Label></Col>
                            <Col className="col-sm-18">
                                <input type="text" name="participantName" value={props.kycCrawlerData.participantName} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter participant name" className="form-control mca-data" required />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col className="col-sm-4" >
                                <Label>Company Address:</Label></Col>
                            <Col className="col-sm-18">
                                <input type="text" name="counterpartyAddress" value={props.kycCrawlerData.counterpartyAddress} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Company address" className="form-control mca-data" required />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col className="col-sm-4" >
                                <Label>Gst:</Label></Col>
                            <Col className="col-sm-18">
                                <input type="text" name="gstNo" value={props.kycCrawlerData.gstNo} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Gst No." className="form-control mca-data" required />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col className="col-sm-4" >
                                <Label>Pan:</Label></Col>
                            <Col className="col-sm-18">
                                <input type="text" name="panNo" value={props.kycCrawlerData.panNo} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Pan No." className="form-control mca-data" required />
                            </Col>
                        </Row>
                        <br />
                    </div>
                    {
                        KYC_DATA_AUTOMATION_VARIABLES.map(dataVariable => {
                            let mcaInputBox;
                            if (props.kycAutomationData) {

                                if (getPanChecks(props.kycAutomationData, dataVariable)) {
                                    mcaInputBox = <input type="text" name='panNumber' value={props.kycCrawlerData.panNumber} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter panNo" className="form-control mca-data" />
                                }
                                else if (getGstFilingChecks(props.kycAutomationData, dataVariable)) {
                                    mcaInputBox = <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="gstNumber" value={props.kycCrawlerData.gstNumber} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Gst No." className="form-control mca-data" />
                                            <input type="text" name="fy" value={props.kycCrawlerData.fy} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Financial Year" className="form-control mca-data" />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                }
                                else if (getBankChecks(props.kycAutomationData, dataVariable)) {
                                    mcaInputBox = <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="accountNo" value={props.kycCrawlerData.accountNo} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Bank Account No." className="form-control mca-data" />
                                            <input type="text" name="ifscCode" value={props.kycCrawlerData.ifscCode} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter IFSC Code" className="form-control mca-data" />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                }



                                else if (getVehicleNumberChecks(props.kycAutomationData, dataVariable)) {
                                    mcaInputBox = <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="vehicleNumber" value={props.kycCrawlerData.vehicleNumber} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Vehicle Number" className="form-control mca-data" />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                }
                                else if (getEmailIdChecks(props.kycAutomationData, dataVariable)) {
                                    mcaInputBox = <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="emailId" value={props.kycCrawlerData.emailId} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter EmailId" className="form-control mca-data" />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                } 
                                else if (getChallanChecks(props.kycAutomationData, dataVariable)) {
                                    mcaInputBox = <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="challanVehicleNumber" value={props.kycCrawlerData.challanVehicleNumber} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Vehicle No." className="form-control mca-data" />
                                            <input type="text" name="last5DigitsOfChasisNo" value={props.kycCrawlerData.last5DigitsOfChasisNo} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Last 5 Digits Of Chasis No." className="form-control mca-data" maxLength="5"/>
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                }

                                else if (getFSSAIChecks(props.kycAutomationData, dataVariable)) {
                                    mcaInputBox = <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="fssaiLicenseNumber" value={props.kycCrawlerData.fssaiLicenseNumber} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter License Number" className="form-control mca-data" />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                }
                                
                                else if (getTanChecks(props.kycAutomationData, dataVariable)) {
                                    mcaInputBox = <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="tanNumber" value={props.kycCrawlerData.tanNumber} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter TAN number" className="form-control mca-data" />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                }

                                else if (getKybChecks(props.kycAutomationData, dataVariable)) {
                                    let inputProps = {
                                        placeholder: "Search Country",
                                        disabled:  false, 
                                        className: "form-control",
                                        required: true,
                                        onChange: (event, { newValue }) => {
                                            this.props.onChange(event,newValue);
                                        }
                                    };
                                    const defaultCompanyName=props.kycCrawlerData.counterpartyName;
                                    mcaInputBox = <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="selectCounterpartyName" defaultValue={defaultCompanyName} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter company name" className="form-control mca-data" required />
                                        </Col>
                                        <Col className="col-sm-24 mt-3">
                                            <input type="text" name="selectRegisterNumber" value={props.kycCrawlerData.registerNumber} onChange={(e) => props.handleKycCrawlerData(e)} placeholder="Enter Register Number" className="form-control mca-data" />
                                        </Col>
                                        <Col className="col-sm-24 mt-3">
                                            <MyAutosuggest type="text" id='countrySearch'
                                                placeholder="Country Name"
                                                searchCallback={props.searchCallback}
                                                onChange={props.handleCountryAutocomplete}
                                                inputProps={inputProps}
                                                searchType="countrySearch"
                                                selectedValueCountry={props.selectedCountry}
                                                />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                }

                                else {
                                    mcaInputBox = ''
                                }
                            }
                            let status = getStatusCheck(dataVariable, props.selectedCounterpartyStatus);
                            let failureReason = getFailureReason(dataVariable, props.selectedCounterpartyStatus);
                            let tempText;
                            if ((status === null || status === undefined)
                                && (failureReason != null && failureReason != undefined && failureReason != "")) {
                                // Failure reason is available but status came null.
                                // Lets consider this as failure
                                tempText = <i className="fa fa-times-circle crawler-status-icon text-danger" title={failureReason}></i>
                            }
                            else if (!status || status.length <= 0 || status === 'START') {
                                tempText = <i className="fa fa-play-circle crawler-status-icon text-primary" title={failureReason}></i>
                            } else if (status === 'SUCCESS') {
                                tempText = <i className="fa fa-check-circle crawler-status-icon text-success" title={failureReason}></i>
                            } else if (status === 'FAILURE') {
                                tempText = <i className="fa fa-times-circle crawler-status-icon text-danger" title={failureReason}></i>
                            } else if (status === 'PARTIAL_FAILURE') {
                                tempText = <i className="fa fa-exclamation-triangle crawler-status-icon text-warning" title={failureReason}></i>
                            } else if (status === 'INPROGRESS') {
                                tempText = <i className="fa fa-spinner crawler-status-icon text-warning" title={failureReason}></i>
                            }
                            return (
                                <Row key={dataVariable}>
                                    <Col sm="2">
                                        {tempText}
                                    </Col>
                                    <Col sm="8">
                                        <label className={(status === "INPROGRESS" && !(props.kycCrawlerData.aadhaarVerificationType && props.kycCrawlerData.aadhaarVerificationType === WITH_OTP)) ? "automation-container disable-container" : "automation-container"}><span>{dataVariable}</span>
                                            <input type="checkbox" disabled={(status === "INPROGRESS" && !(props.kycCrawlerData.aadhaarVerificationType && props.kycCrawlerData.aadhaarVerificationType === WITH_OTP)) ? true : false} name={dataVariable} checked={(props.kycAutomationData[dataVariable] === true) ? true : false} onChange={props.handleKycCheckboxchange} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </Col>
                                    <Col sm="14">
                                        {mcaInputBox}
                                    </Col>

                                </Row>
                            )
                        })
                    }
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button Color="secondary" onClick={props.close}>Close</Button>
                <Button Color="primary" className='data-automation-run' onClick={props.handleKycCrawlerRunAutomation}>Run</Button>
            </ModalFooter>
        </div>

    )
}